import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {BehaviorSubject} from "rxjs";
import {Chronology, MapFilter} from "../model/chronology";
import {MapSettings} from "../model/map";


const CHRONOLOGY = 'chronology';
const MAPFILTER = 'mapFilter';
@Injectable({
  providedIn: 'root'
})
export class ChronologyService {
  constructor() {}
  private chronology: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  private mapFilter: BehaviorSubject<MapFilter> = new BehaviorSubject<MapFilter>(new MapFilter());

  getActiveChronology() {
    const json = window.localStorage.getItem(CHRONOLOGY);
    if (json) {
      this.chronology.next(Number(json));
    } else {
      this.chronology.next(0)
    }
    return this.chronology.value ?? 0;
  }

  setActiveChronology(value: number) {
    window.localStorage.setItem(CHRONOLOGY, JSON.stringify(value));
    this.chronology.next(value);
  }

  getMapFilter() {
    const json = window.localStorage.getItem(MAPFILTER);
    if (json != null) {
      this.mapFilter.next(new MapFilter(JSON.parse(json)));
    }
    return this.mapFilter.value;
  }

  setMapFilter(value: MapFilter) {
    window.localStorage.setItem(MAPFILTER, JSON.stringify(value));
    this.mapFilter.next(value);
  }
}
